import axios from 'axios';

export default () => axios.post(`/v1/announcements/mark-all-as-read`);
